module.exports = __webpack_public_path__ + "img/icon12.18747313.png";